import React from 'react';
import EmojiLoader from '../../../zolaUI/EmojiLoader';

import './ImportLoader.styles.less';

const ImportLoader = () => {
  return (
    <React.Fragment>
      <EmojiLoader infinite className="upload-csv__loading-emojis"/>
      <h4 className="upload-csv__loading-txt">Uploading your spreadsheet…</h4>
    </React.Fragment>
  );
}

export default ImportLoader;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/ImportLoader.jsx